export const DEFAULT_DATA = {}
export const DEFAULT_DATA_ITEM = {
  loading: false,
  loaded: false as const,
  error: undefined,
  data: undefined,
}
